import { useState } from 'react'
import {
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useGetSubstancesQuery
} from 'prove-common'
import { SubstancesTable } from '../tables/substances-table/SubstancesTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { SubstanceForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const SubstancesScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const {
    data: substances,
    isFetching,
    isError,
    refetch
  } = useGetSubstancesQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Substanser' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Substanser'
            description='Substanser som knyttes til analysetyper, med koder og valgfrie visningsnavn.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til substans
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={substances != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {substances ? <SubstancesTable substances={substances} /> : null}
      </ScreenLayout>
      {isModalOpen && <SubstanceForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
